@defer (when claim) {
    <div class="container mt-4">
        <div class="row justify-content-center">
            <div class="col-12 w-100">
                <div class="heading-lg text-center">{{ claim?.policyType }}</div>
                <div class="heading-md text-center mb-3">{{ claim?.coverageType }} Claim</div>
                <div class="heading-sm mb-4 text-center">To be completed by the employer</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <div class="card">
                    <!-- Using a custom class instead of overriding padding -->
                    <div class="card-body">
                        <form [formGroup]="claimForm">
                            <div class="row mb-4">
                                <div class="col-12">
                                    <div class="caption">
                                        Claim number:&nbsp;
                                        <span class="caption-lg">{{ claim?.claimReferenceNumber }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="heading-sm mb-4">I hereby certify to A.W.G. Dewar, Inc. that:</div>
                                </div>
                            </div>
                            <fieldset formGroupName="employerParent">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="firstName" class="form-label">Employee first name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="firstName"
                                                formControlName="firstName"
                                                appShowFieldErrors="Employee first name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="lastName" class="form-label">Employee last name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="lastName"
                                                formControlName="lastName"
                                                appShowFieldErrors="Employee last name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="row align-items-top">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="employerEmployeeStartDate" class="form-label">Employee start date</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="employerEmployeeStartDate"
                                                formControlName="employerEmployeeStartDate"
                                                placeholder="mm/dd/yyyy"
                                                name="employerEmployeeStartDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #employerEmployeeStartDate="ngbDatepicker"
                                                appShowFieldErrors="Employee start date"
                                                (ngModelChange)="validateDateRange('employerEmployeeStartDate', 'employerUnemploymentStartDate')" />

                                            <button class="btn btn-input-group" type="button" (click)="employerEmployeeStartDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="employerUnemploymentStartDate" class="form-label">Date unemployment began</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="employerUnemploymentStartDate"
                                                formControlName="employerUnemploymentStartDate"
                                                placeholder="mm/dd/yyyy"
                                                name="employerUnemploymentStartDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #employerUnemploymentStartDate="ngbDatepicker"
                                                appShowFieldErrors="Date unemployment began"
                                                (ngModelChange)="validateDateRange('employerEmployeeStartDate', 'employerUnemploymentStartDate')" />
                                            <button class="btn btn-input-group" type="button" (click)="employerUnemploymentStartDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row align-items-top">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="employerUnemploymentNotificationDate" class="form-label">Date first notified of involuntary unemployment</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="employerUnemploymentNotificationDate"
                                                formControlName="employerUnemploymentNotificationDate"
                                                placeholder="mm/dd/yyyy"
                                                name="employerUnemploymentNotificationDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minConsultDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #employerUnemploymentNotificationDate="ngbDatepicker"
                                                appShowFieldErrors="First notified date" />
                                            <button class="btn btn-input-group" type="button" (click)="employerUnemploymentNotificationDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-xl-7">
                                    <div class="form-group mb-4">
                                        <label for="employerEmploymentType" class="form-label me-2">Employee was</label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="employerEmploymentTypeFullTime"
                                                        class="radio-checkbox-input"
                                                        formControlName="employerEmploymentType"
                                                        value="Full Time" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Full Time</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="employerEmploymentTypePartTime"
                                                        class="radio-checkbox-input"
                                                        formControlName="employerEmploymentType"
                                                        value="Part Time"
                                                        appShowFieldErrors="Selection" />

                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Part Time</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-5">
                                    <div class="form-group mb-4">
                                        <label for="employerPartTimeHoursPerWeek" class="form-label">Hours per week if part time</label>
                                        <input
                                            type="text"
                                            id="employerPartTimeHoursPerWeek"
                                            class="form-control"
                                            formControlName="employerPartTimeHoursPerWeek"
                                            appShowFieldErrors="Hours per week"
                                            currencyFormat
                                            placeholder="0"
                                            inputmode="number"
                                            maxlength="9"
                                            maxDigits="6"
                                            appShowFieldErrors="Hours per week" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-xl-8">
                                    <div class="form-group mb-4">
                                        <label for="employerUnemploymentType" class="form-label me-2">Please indicate if unemployment was</label>
                                        <fieldset class="radio-checkboxes">
                                            <div class="radio-checkboxes-tiles">
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="employerUnemploymentTypeVoluntary"
                                                        class="radio-checkbox-input"
                                                        formControlName="employerUnemploymentType"
                                                        value="Voluntary" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Voluntary</span>
                                                    </div>
                                                </label>
                                                <label class="radio-checkbox">
                                                    <input
                                                        type="radio"
                                                        id="employerUnemploymentTypeInvoluntary"
                                                        class="radio-checkbox-input"
                                                        formControlName="employerUnemploymentType"
                                                        value="Involuntary"
                                                        appShowFieldErrors="Selection" />
                                                    <div class="radio-checkbox-content-area">
                                                        <span class="radio-checkbox-title">Involuntary</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="employerUnemploymentReason" class="form-label">Reason for unemployment:</label>
                                        <textarea
                                            type="text"
                                            id="employerUnemploymentReason"
                                            class="form-control"
                                            formControlName="employerUnemploymentReason"
                                            appShowFieldErrors="Unemployment reason"
                                            maxlength="1000"
                                            (input)="updateCharacterCount($event, 'employerUnemploymentReason')"></textarea>
                                        <div class="text-small form-text text-end char-count">{{ characterCounts.employerUnemploymentReason }}/1000 characters</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4 mt-4">
                                <div class="col-12">
                                    <div class="section-heading">Employer Information</div>
                                </div>
                            </div>
                            <fieldset formGroupName="employer">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group mb-4 position-relative">
                                            <label for="organizationName" class="form-label">Company name</label>
                                            <textarea
                                                type="text"
                                                id="organizationName"
                                                class="form-control"
                                                formControlName="organizationName"
                                                appShowFieldErrors="Company name"
                                                maxlength="255"
                                                (input)="updateCharacterCount($event, 'organizationName')"></textarea>
                                            <div class="text-small form-text text-end char-count">{{ characterCounts.organizationName }}/255 characters</div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset formGroupName="employer">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="phone" class="form-label">Phone</label>
                                            <input
                                                type="tel"
                                                class="form-control"
                                                id="phone"
                                                inputmode="tel"
                                                placeholder="(555) 555-5555"
                                                mask="(000) 000-0000"
                                                #phone
                                                formControlName="phoneNumber"
                                                appShowFieldErrors="Phone" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="emailAddress" class="form-label">Email address</label>
                                            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" appShowFieldErrors="Email" maxlength="255" />
                                        </div>
                                    </div>
                                    <!--                                <div class="col-12 col-lg-6 mb-lg-0 d-flex align-items-center">
                                        <div class="form-text email-address">Email is only used for claim processing/questions.</div>
                                    </div> -->
                                </div>
                            </fieldset>
                            <fieldset formGroupName="employer">
                                <div class="row"></div>
                                <div class="row">
                                    <div class="col-12" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="address1" class="form-label">Address</label>
                                            <input type="text" class="form-control" id="address1" formControlName="address1" appShowFieldErrors="Address" maxlength="200" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    @if (showAddress2) {
                                        <div class="col-12" formGroupName="address">
                                            <div class="form-group mb-4">
                                                <label for="address2" class="form-label">Building, apartment, floor or other</label>
                                                <input type="text" class="form-control" id="address2" formControlName="address2" maxlength="200" />
                                            </div>
                                        </div>
                                    } @else {
                                        <a class="form-text mb-3" (click)="toggleAddress2()">+ Add building, apartment, floor or other</a>
                                    }
                                </div>
                                <div class="row">
                                    <div class="col-12" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="city" class="form-label">City</label>
                                            <input type="text" class="form-control" id="city" formControlName="city" appShowFieldErrors="City" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="state" class="form-label">{{ stateCaption }}</label>
                                            <select id="state" class="form-control form-select" formControlName="stateAbbreviation" appShowFieldErrors="{{ stateCaption }}">
                                                <option></option>
                                                @for (state of filteredStates; track $index) {
                                                    <option [value]="state.stateAbbreviation">{{ state.stateName }}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" formGroupName="address">
                                        <div class="form-group mb-4">
                                            <label for="postalCode" class="form-label">{{ postalCodeCaption }}</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="postalCode"
                                                formControlName="postalCode"
                                                appShowFieldErrors="{{ postalCodeCaption }}"
                                                maxlength="10" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-xl-6" formGroupName="address">
                                        <label for="country" class="form-label">Country/Region</label>
                                        <div class="form-group mb-4">
                                            <select
                                                id="country"
                                                class="form-control form-select"
                                                formControlName="countryISO3"
                                                appShowFieldErrors="Country"
                                                (change)="onCountryChange($event)">
                                                <option></option>
                                                @for (country of countries; track $index) {
                                                    <option [value]="country.iso3">{{ country.countryName }}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row">
                                <div class="col-12">
                                    <div class="caption mb-3">{{ employerCertificationText }}</div>
                                </div>
                            </div>

                            <!--                             <div class="row mb-4 mt-4">
                                <div class="col-12">
                                    <div class="section-heading">Physician Information</div>
                                </div>
                            </div>
 -->
                            <fieldset>
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="employerCertifyingOfficialName" class="form-label">Name of company official</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="employerCertifyingOfficialName"
                                                formControlName="employerCertifyingOfficialName"
                                                appShowFieldErrors="Company official"
                                                maxlength="255" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="employerCertifyingOfficialTitle" class="form-label">Title</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="employerCertifyingOfficialTitle"
                                                formControlName="employerCertifyingOfficialTitle"
                                                appShowFieldErrors="Title"
                                                maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="employerCertifyingOfficialContact" class="form-label">Telephone number / email address of company official:</label>
                                        <textarea
                                            type="text"
                                            id="employerCertifyingOfficialContact"
                                            class="form-control"
                                            formControlName="employerCertifyingOfficialContact"
                                            appShowFieldErrors="Telephone number / email address of company official"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'employerCertifyingOfficialContact')"></textarea>
                                        <div class="col-12 col-lg-12 d-flex justify-content-between">
                                            <div class="form-text email-address">(For claim verification purposes only)</div>
                                            <div class="text-small form-text text-end char-count">{{ characterCounts.employerCertifyingOfficialContact }}/255 characters</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4">
                                        <label for="employerSignature" class="form-label">Signature</label>
                                        <app-signature-pad formControlName="employerSignature" appShowFieldErrors="Signature"></app-signature-pad>
                                        <div class="text-small form-text mt-2">{{ signatureText }}</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-link" (click)="fraudNotice()">Important fraud information regarding your claim</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="caption mt-3" [innerHTML]="instructionText"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button
                                    class="btn btn-primary me-3 mt-5 mb-5"
                                    (click)="onSubmit()"
                                    (keydown.enter)="onSubmit()"
                                    [disabled]="isSaving"
                                    [class.btn--waiting]="isSaving">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fraud Notices Modal Template -->
} @placeholder {
    <div class="container mt-4">
        <div class="row text-center">
            <div class="col-12 heading-md pb-2">Loading Claim...</div>
        </div>
    </div>
}
